import React, { useEffect, useState } from "react";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { getReflectionPrompts, myReflections, createReflection } from "@/lib/api";
import { toast } from "sonner";

export default function Journal() {
  const { lang } = useApp();
  const t = useAppUi(lang);
  const [prompts, setPrompts] = useState([]);
  const [entries, setEntries] = useState([]);
  const [promptId, setPromptId] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => myReflections().then(setEntries).catch(() => {});
  useEffect(() => { getReflectionPrompts().then(setPrompts).catch(() => {}); load(); }, []);

  const submit = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const prompt = prompts.find((p) => p.id === promptId);
      await createReflection({ text, prompt_id: promptId || null, prompt_text: prompt?.prompt_text || null, training_date: prompt?.training_date || null });
      setText("");
      setPromptId("");
      toast.success(t("toastRefSaved"));
      load();
    } finally { setBusy(false); }
  };

  return (
    <PLayout>
      <h1 className="rbl-h1" style={{ fontSize: 36 }}>📓 {t("jrTitle")}</h1>
      <p className="rbl-intro">{t("jrIntro")}</p>

      <div className="rbl-worksheet" style={{ marginTop: 18 }} data-testid="journal-form">
        <div className="rbl-field">
          <label className="rbl-label">{t("jrPromptLabel")}</label>
          <select className="rbl-input" value={promptId} onChange={(e) => setPromptId(e.target.value)} data-testid="journal-prompt">
            <option value="">{t("jrFree")}</option>
            {prompts.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
          </select>
          {promptId && <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 8 }}>{prompts.find((p) => p.id === promptId)?.prompt_text}</p>}
        </div>
        <div className="rbl-field">
          <label className="rbl-label">{t("jrYour")}</label>
          <textarea className="rbl-input" value={text} onChange={(e) => setText(e.target.value)} data-testid="journal-text" />
        </div>
        <button className="rbl-btn block" onClick={submit} disabled={busy || !text.trim()} data-testid="journal-save">
          {busy ? t("jrSaving") : t("jrSave")}
        </button>
      </div>

      <h2 className="rbl-section-title" style={{ marginTop: 32 }}>{t("jrMine")}</h2>
      <div data-testid="journal-entries">
        {entries.length === 0 && <p style={{ color: "var(--muted)" }}>{t("jrNone")}</p>}
        {entries.map((e) => (
          <div key={e.id} className="rbl-list-item" style={{ display: "block" }}>
            {e.prompt_text && <div style={{ color: "var(--navy)", fontWeight: 700, fontSize: 14 }}>{e.prompt_text}</div>}
            <div style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{e.text}</div>
            <div style={{ color: "var(--muted)", fontSize: 12, marginTop: 8 }}>{new Date(e.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </PLayout>
  );
}
